<template>
  <li class="list">
    <button class="routerLogoutLink" :style="logoutCustomStyle" @click="logout">
      Logout
    </button>
  </li>
</template>

<style scoped>
.routerLogoutLink {
  display: flex;
  align-items: center;
  background-color: transparent;
  font-size: 1.2rem;
  padding: 0 0.75em;
  height: 50px;
  font-weight: bold;
  transition: all 0.2s ease-in-out;
  border-width: 0px 3px 0px 3px;
  border-style: groove;
  border-color: #822e21;
}
.routerLogoutLink:hover {
  background-color: #822e21;
  box-shadow: 0 5px 12px #822e21;
  color: black;
  border-radius: 0.25rem;
}

.list {
  transition: all 0.2s ease-in-out;
  margin: 0 10px;
}

@media (max-width: 1200px) {
  .list {
    display: none;
  }
}
</style>
<script>
import { mapGetters } from "vuex";
import { SetStoreLoginedValues } from "../../../customFunctions/Auth.js";
export default {
  name: "navbar-logout-button",
  methods: {
    logout() {
      SetStoreLoginedValues(this.$store, false, this.$router);
    },
  },
  components: {},
  computed: {
    ...mapGetters(["getDarkMode"]),
    logoutCustomStyle() {
      return {
        color: this.getDarkMode === false ? "#344767" : "white",
      };
    },
  },
};
</script>
